import PATHS from '../constants';

function fetchBrands() {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    return fetch(PATHS.HOME_BRANDS, {
        method: 'GET',
        dataType: 'json',
        headers,
    });
};

export default fetchBrands;